import type { AffiliationInput, AffiliationEntry } from "../affiliations.types";

/**
 * Converts AffiliationEntry[] (UI format) to AffiliationInput[] (API payload).
 * Handles both existing selections (numeric IDs) and new entries (with "new-" prefix).
 */
export function orgRoleEntriesToAffiliationInputs(
  entries: AffiliationEntry[]
): AffiliationInput[] {
  return entries
    .filter((entry) => entry.organization && entry.role)
    .map((entry, index) => {
      const orgValue = entry.organization!.value;
      const roleValue = entry.role!.value;

      const input: AffiliationInput = {
        display_order: index,
      };

      // Organization: check if it's a newly created option
      if (typeof orgValue === "string" && orgValue.startsWith("new-")) {
        input.organization_name =
          entry.organization!.data?.name || entry.organization!.label;
      } else {
        input.organization_id = Number(orgValue);
      }

      // Role: check if it's a newly created option
      if (typeof roleValue === "string" && roleValue.startsWith("new-")) {
        input.role_name = entry.role!.data?.name || entry.role!.label;
      } else {
        input.affiliation_role_id = Number(roleValue);
      }

      return input;
    });
}
